<ng-container>
  <div class="position-relative">
    <input
      type="month"
      [ngModel]="selectedMonthFormatted"
      [attr.placeholder]="placeholder"
      class="form-control form-control-date1 form-control-sm"
      autocomplete="off"
      name="date"
      [attr.min]="minAllowedDate ? (minAllowedDate | date: 'yyyy-MM') : null"
      [attr.max]="maxAllowedDate ? (maxAllowedDate | date: 'yyyy-MM') : null"
      (ngModelChange)="onSelectedDateChange($event)"
    />
  </div>
</ng-container>
